import { Map } from 'immutable';

import { getInventoryOperationValue } from '../../../product/getOperationValue';

import { DIMENSIONS, OPERATIONS } from '../../../../constants/product';
import { SIZE_OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { FAIRE } from '../../../../constants/channels';

export function shippingDimensions({ channel, preview }) {
  const operation = preview.getIn([ATTRIBUTE.SHIPPING, 'operation']);

  function makeOperation(result, attribute) {
    if (preview.getIn([ATTRIBUTE.SHIPPING, attribute])) {
      const type = SIZE_OPERATIONS[channel][operation][attribute];
      const value = preview.getIn([ATTRIBUTE.SHIPPING, attribute]);
      result.push(Map({ type, value }));
    }

    return result;
  }

  switch (channel) {
    case FAIRE: {
      const payload = DIMENSIONS[FAIRE].reduce(makeOperation, []);

      if (preview.hasIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.DISTANCE_UNIT])) {
        payload.push(
          Map({
            type: OPERATIONS[FAIRE].DISTANCE_UNIT,
            value: getInventoryOperationValue({
              channel,
              type: ATTRIBUTE.DISTANCE_UNIT,
              value: preview.getIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.DISTANCE_UNIT]),
            }),
          })
        );
      }

      return { payload };
    }

    default: {
      return { payload: DIMENSIONS[channel].reduce(makeOperation, []) };
    }
  }
}
